import { render, staticRenderFns } from "./AnmeldungAlertModal.vue?vue&type=template&id=0a3e804e&"
import script from "./AnmeldungAlertModal.vue?vue&type=script&lang=js&"
export * from "./AnmeldungAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports